<div *ngIf="config.InformationalMessage" class="infoMessage">{{config.InformationalMessage}}</div>
<mat-dialog-content>
    <app-e-form-viewer [configInput]="config" [changesInput]="changes" style="display: flex; flex:1;"></app-e-form-viewer>
</mat-dialog-content>

<mat-dialog-actions>
    <div class='flex-footer-left'>
        <tyl-button image="save.png" label="Accept and Process" (clickEvent)="acceptClick()" *ngIf="isReview">
        </tyl-button>
        <tyl-button image="block.png" label="Reject" (clickEvent)="rejectClick()" *ngIf="isReview"></tyl-button>
        <tyl-button image="previous arrow.png" disabledImage="previous arrow disabled.png" label="Previous"
            (clickEvent)="previousClick()" [disabled]="isFP" *ngIf="showNextPreviousButtons"></tyl-button>
    </div>
    <div class="flex-footer-middle">
        <tyl-button image="notes.png" label="Notes" (clickEvent)="notesClick()" *ngIf="isReview"></tyl-button>
    </div>
    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="next arrow.png" disabledImage="next arrow disabled.png" label="Next"
            (clickEvent)="nextClick()" [disabled]="isLP" *ngIf="showNextPreviousButtons"></tyl-button>
        <tyl-button image="print.png" *ngIf="config.ShowPrintButton" label="Print" (clickEvent)="printClick()">
        </tyl-button>

        <tyl-button image="save.png" label="Submit" (clickEvent)="submitClick('Submit');validationTrigger.click();"
            *ngIf="!isPreview && isLP && !isReview && editable && !config.DisableSubmission"></tyl-button>
        <tyl-button image="clock.png" [iconWidth]="25" label="Save and Finish Later" (clickEvent)="submitClick('SubmitLater')"
            *ngIf="!isPreview && !isReview && editable && !config.DisableSubmission"></tyl-button>

        <!-- <tyl-button image="save.png" label="Submit" (clickEvent)="submitClick();validationTrigger.click();"
            *ngIf="!isPreview && isLP && !isReview && editable && !config.DisableSubmission && V10"></tyl-button>
        <tyl-button image="clock.png" [iconWidth]="25" label="Save and Finish Later" (clickEvent)="saveClick()" 
            *ngIf="!isPreview && !isReview && editable && !config.DisableSubmission && V10"></tyl-button> -->



        <tyl-button image="cancel.png" [label]="isPreview || config.DisableSubmission ? 'Close' : 'Cancel'"
            (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>

<input style="display:none" type="submit" form="vForm" #validationTrigger>
